import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-8 px-4 bg-gaming-bg border-t border-gaming-purple/10" data-id="element-46">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-gray-500" data-id="element-47">
          <span data-id="element-48">
            &copy; {new Date().getFullYear()} Todos los derechos reservados.
          </span>
          <div className="flex items-center gap-6" data-id="element-49">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-gaming-purple-light transition-colors underline underline-offset-4 decoration-gray-700 hover:decoration-gaming-purple-light" data-id="element-50">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-gaming-purple-light transition-colors underline underline-offset-4 decoration-gray-700 hover:decoration-gaming-purple-light" data-id="element-51">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {activeModal && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-52">
          <div className="relative w-full max-w-2xl max-h-[80vh] bg-gaming-card border border-gaming-purple/30 rounded-2xl box-glow-purple overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-53">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-6 py-4 border-b border-gaming-purple/20 bg-gaming-bg" data-id="element-54">
              <h3 className="font-orbitron font-bold text-white text-lg" data-id="element-55">
                {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setActiveModal(null)} className="text-gray-400 hover:text-white transition-colors p-1" data-id="element-56">
                <XIcon className="w-5 h-5" data-id="element-57" />
              </button>
            </div>

            {/* Modal Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-64px)] text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-58">
              {activeModal === 'privacy' ? <PrivacyContent data-id="element-59" /> : <TermsContent data-id="element-60" />}
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-gray-400 text-xs uppercase tracking-wider" data-id="element-61">
        Última actualización: Marzo 2026
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-62">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-63">
        Recopilamos la información que nos proporcionas directamente al realizar
        una compra, incluyendo tu nombre, dirección de correo electrónico y
        datos de pago. Los datos de pago son procesados de forma segura por
        nuestro proveedor de pagos y no almacenamos información de tarjetas de
        crédito.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-64">
        2. Uso de la Información
      </h4>
      <p data-id="element-65">
        Utilizamos tu información para: procesar tu compra y entregarte acceso
        al producto digital, enviarte actualizaciones relacionadas con tu
        compra, y mejorar nuestros productos y servicios.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-66">
        3. Protección de Datos
      </h4>
      <p data-id="element-67">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-68">
        4. Cookies
      </h4>
      <p data-id="element-69">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación y analizar el tráfico del sitio. Puedes configurar tu
        navegador para rechazar cookies, aunque esto podría afectar la
        funcionalidad del sitio.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-70">
        5. Terceros
      </h4>
      <p data-id="element-71">
        No vendemos, intercambiamos ni transferimos tu información personal a
        terceros, excepto a proveedores de servicios de confianza que nos
        asisten en la operación del sitio y el procesamiento de pagos.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-72">
        6. Tus Derechos
      </h4>
      <p data-id="element-73">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes contactarnos a
        través de los canales proporcionados.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-gray-400 text-xs uppercase tracking-wider" data-id="element-74">
        Última actualización: Marzo 2026
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-75">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-76">
        Al acceder y realizar una compra en este sitio, aceptas estar sujeto a
        estos Términos y Condiciones. Si no estás de acuerdo con alguna parte de
        estos términos, no debes utilizar nuestros servicios.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-77">
        2. Producto Digital
      </h4>
      <p data-id="element-78">
        El producto ofrecido es un recurso educativo digital. El acceso se
        otorga inmediatamente después de la confirmación del pago. El contenido
        es para uso personal y no puede ser redistribuido, revendido ni
        compartido.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-79">
        3. Política de Reembolso
      </h4>
      <p data-id="element-80">
        Debido a la naturaleza digital del producto y al acceso inmediato
        proporcionado, todas las ventas son finales. No se ofrecen reembolsos
        una vez que se ha entregado el acceso al contenido.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-81">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-82">
        Todo el contenido incluido en el producto digital, incluyendo textos,
        gráficos, estrategias y metodologías, está protegido por derechos de
        autor. Queda prohibida su reproducción o distribución sin autorización
        expresa.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-83">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-84">
        Los resultados pueden variar según la dedicación y esfuerzo individual.
        No garantizamos ingresos específicos ni resultados financieros. El
        contenido es educativo y los resultados dependen de la aplicación
        individual.
      </p>

      <h4 className="font-orbitron text-white font-bold text-base mt-4" data-id="element-85">
        6. Modificaciones
      </h4>
      <p data-id="element-86">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor inmediatamente después de
        su publicación en el sitio.
      </p>
    </>;
}